import { alertConstants } from "../_constants";

export const alertAction = {
    hide,
    show
}

function hide() {
    return function (dispatch: any){
        dispatch({
            type: alertConstants.ALERT_HIDE
        });
    }
}

function show() {
    return function (dispatch: any){
        dispatch({
            type: alertConstants.ALERT_SHOW,
            notification:
                {
                    message: "Test",
                    level: "notification"
                }
        });
    }
}